// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"9faf6fb9","131":"34c5eb72"}[chunkId] + ".chunk.js";
};